import { utagLinkPDP } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

const initOptionsSlidersDesktop = () => {

	const trackProductPageEvents = utagLinkPDP();
	const optionsSliderContainerSelectors = [ '#pdScrollableShadeOptions', '#pdScrollableBaseOptions' ];
	let videoPlayButtonHidden = false;

	function getSliderImages () {

		const reducerFunction = (accum, currentValue) => {

			const imgElements = document.querySelectorAll(`${currentValue} img`);
			return imgElements.length ? accum.concat(Array.from(imgElements)) : accum;

		};

		return optionsSliderContainerSelectors.reduce(reducerFunction, []);

	}

	function trackShadeAndBaseColorWidget (widget, eventAction, eventName, listItemSelector) {

		trackProductPageEvents({
			eventAction: `Load-${eventAction}`,
			nonInteraction: 1
		});
		setGenericEvent({
			event_name: `pdp_${eventName}_load`,
			pdp_item_id: window.shortSku,
			pdp_prime_cat: window.productCategory
		});

		widget.querySelectorAll(listItemSelector).forEach((item, i) => {

			item.addEventListener('click', (e) => {

				const { href } = e.currentTarget;
				const { sku } = item.querySelector('img').dataset;

				if (href) {

					trackProductPageEvents({
						eventAction: `Select-${eventAction}`,
						eventLabel: href
					});
					setGenericEvent({
						event_name: `pdp_${eventName}_select`,
						pdp_item_id: window.shortSku,
						pdp_prime_cat: window.productCategory,
						selected_item_id: sku,
						item_position_number: i + 1
					});

				}

			});

		});

	}

	function init () {

		getSliderImages().forEach((img) => {

			img.addEventListener('mouseenter', (event) => {

				const activeHeroElement = document.querySelector('.pdImgWrap.active .pdProdImg');
				const videoSpanElement = document.querySelector('#pdImgContainer .playButton');
				const newUrl = event.target.dataset.srcHero;

				if (activeHeroElement && newUrl) {

					if (videoSpanElement) {

						videoSpanElement.classList.add('hidden');
						videoPlayButtonHidden = true;

					}

					// store original src for hero image before mouse leave
					activeHeroElement.setAttribute('data-original-src', activeHeroElement.src);
					activeHeroElement.src = newUrl;
					activeHeroElement.alt = event.target.alt || '';

				}

			});

			img.addEventListener('mouseleave', () => {

				const activeHeroElement = document.querySelector('.pdImgWrap.active .pdProdImg');
				const { originalSrc } = activeHeroElement.dataset;

				if (activeHeroElement && originalSrc) {

					// set hero image to original source when mouse leaves
					activeHeroElement.src = originalSrc;

					if (videoPlayButtonHidden) {

						document.querySelector('#pdImgContainer .playButton').classList.remove('hidden');
						videoPlayButtonHidden = false;

					}

				}

			});

		});

		optionsSliderContainerSelectors.forEach((widgetSelector) => {

			const widget = document.querySelector(widgetSelector);

			if (widget) {

				if (!widgetSelector.includes('Other')) {

					trackShadeAndBaseColorWidget(
						widget,
						`ColorPlus-${widgetSelector.includes('Shade') ? 'Shade' : 'Base-Color'}-Options`,
						`colorplus_${widgetSelector.includes('Shade') ? 'shadeoptions' : 'basecolor'}`,
						'.pdOtherOptionsThumb'
					);

				}

			}

		});

	}

	return init();

};

export default initOptionsSlidersDesktop;
